/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { filterByPendingServiceRequests } from 'app/pages/PurchasingRequest/Helpers/filters'

export default class PurchasingRequestNormalizer {
  static normalize(
    memberResponse: MemberSerializerResponse<IPurchasingRequest>
  ): IPurchasingRequest {
    const data = memberResponse.data.attributes
    const products = memberResponse.included
      .filter((data) => data.type === 'product_request_item')
      .map((product) => product.attributes)

    const mainItems = products.filter((requestItem) => !requestItem.parent_id)
    const deliveryItems = memberResponse.included
      .filter((data) => data.type === 'delivery_request_item')
      .map((product) => product.attributes)

    const rental = memberResponse.included.find((data) => data.type === 'rental')
      ?.attributes as IRental

    const openServiceRequests = memberResponse.included
      .filter((data) => data.type === 'product_request_item')
      .map((data) => data.attributes)
      .filter(filterByPendingServiceRequests)

    return {
      ...data,
      rental,
      open_with_overview: false, // Not used -> TODO: remove
      rental_request_deliveries: deliveryItems.map(normalizeDeliveryRequestItem),
      rental_request_items: mainItems.map((mainRequestItem) =>
        normalizeProductRequestItem(mainRequestItem, {
          products: products,
          supplier_station_id: data.supplier_station_id
        })
      ),
      open_service_requests: openServiceRequests.map((item) =>
        normalizeProductRequestItem(item, {
          products: products,
          supplier_station_id: data.supplier_station_id
        })
      )
    }
  }
}

type AdditionalAttributes = {
  supplier_station_id: number
  products: any[]
}
const normalizeProductRequestItem = (
  requestItem: IProductRequestItem,
  additionalAttributes: AdditionalAttributes
): IProductRequestItem => {
  const subItems: IProductRequestItem[] = additionalAttributes.products
    .filter((productItem: any) => productItem.parent_id === requestItem.id)
    .map((subItem: any) => normalizeProductRequestItem(subItem, additionalAttributes))

  return {
    ...requestItem,
    name: requestItem.item.name,
    unit_price: requestItem.net_price,
    supplier_station_id: additionalAttributes.supplier_station_id,
    sub_rental_request_items: subItems,
    line_item: {
      ...requestItem.item,
      category_segment_id: requestItem.item.catalog_info_id,
      category_segment_name: requestItem.item.name,
      free: requestItem.included || false,
      line_item_id: requestItem.parent_id,
      line_item_type: requestItem.item.item_type,
      attribute_values: requestItem.item.specifications.map(normalizeSpecification)
    }
  }
}

const mapDeliveryType = (type: string) => (type === 'return' ? 'return_delivery' : type)
const normalizeDeliveryRequestItem = (deliveryItem: IDeliveryRequestItem): IDeliveryRequestItem => {
  return {
    ...deliveryItem,
    unit_price: deliveryItem.net_price,
    name: deliveryItem.item.name,
    delivery_date: deliveryItem.item.delivery_date,
    line_item_type: mapDeliveryType(deliveryItem.item.delivery_type),
    cargos: deliveryItem.cargos
  }
}

const normalizeSpecification = (spec: ISpecification, index: number): IAttributeValue => ({
  id: index,
  question: spec.name,
  display_value: spec.value
  // metric -> TODO: add metric
})
